"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totalDaysDelinquent = totalDaysDelinquent;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

// eslint-disable-next-line import/prefer-default-export
function totalDaysDelinquent(delinquentSinceDate) {
  if (delinquentSinceDate) {
    var delinquentDate = (0, _momentTimezone["default"])(delinquentSinceDate).tz('America/Denver');
    return delinquentDate.diff((0, _momentTimezone["default"])().startOf('day'), 'days');
  }

  return 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/util/delinquencyUtils.js
// module id = 3671
// module chunks = 25